import { PHONE_CHECK_MESSAGE, SERVER_ERROR_MESSAGE } from '@/lib/config'

function isPhoneField(key) {
  return key === 'phone' || key.endsWith('.phone') || key.endsWith('[phone]')
}

function isFieldBag(bag) {
  return !!bag && typeof bag === 'object' && !Array.isArray(bag)
}

function fieldBagHasPhone(bag) {
  if (!isFieldBag(bag)) return false
  return Object.keys(bag).some(isPhoneField)
}

function hasPhoneFieldError(data) {
  if (!data || typeof data !== 'object') return false
  return fieldBagHasPhone(data.errors) || fieldBagHasPhone(data.error)
}

function messagesFromBag(bag, skipPhone) {
  if (!isFieldBag(bag)) return []

  const messages = []
  Object.keys(bag).forEach((key) => {
    if (skipPhone && isPhoneField(key)) return

    const value = bag[key]
    if (typeof value === 'string' && value.trim()) {
      messages.push(value.trim())
      return
    }

    if (!Array.isArray(value)) return
    value.forEach((item) => {
      if (typeof item === 'string' && item.trim()) messages.push(item.trim())
    })
  })

  return messages
}

function topLevelMessage(data) {
  if (typeof data === 'string' && data.trim()) return data.trim()
  if (!data || typeof data !== 'object') return ''
  if (typeof data.message === 'string' && data.message.trim()) return data.message.trim()
  if (typeof data.error === 'string' && data.error.trim()) return data.error.trim()
  return ''
}

function validationErrorText(data, skipPhone) {
  if (!data || typeof data !== 'object') return topLevelMessage(data)

  const messages = [
    ...messagesFromBag(data.errors, skipPhone),
    ...messagesFromBag(data.error, skipPhone),
  ]
  if (messages.length) return messages.join(' ')
  if (skipPhone) return ''
  return topLevelMessage(data)
}

export function getFormSubmitErrorMessage(error) {
  const status = Number(error && error.httpStatus)
  if (!status) return ''

  if (status === 422) {
    const data = error.data
    const phoneError = hasPhoneFieldError(data)
    const parts = []
    if (phoneError) parts.push(PHONE_CHECK_MESSAGE)

    const otherText = validationErrorText(data, phoneError)
    if (otherText) parts.push(otherText)
    return parts.join(' ')
  }

  if (status >= 500 && status < 600) return SERVER_ERROR_MESSAGE
  return ''
}
